<div class="main-content table-page table-page--compact areas-page">
  <div class="container-fluid">
    <section class="table-page__hero">
      <div class="table-page__copy">
        <h1>Gestión de Áreas</h1>
        <p>Administre áreas, tipo de atención y el servicio default para tickets desde una sola vista.</p>
      </div>

      <div class="table-page__toolbar-actions">
        <button *ngIf="regresaPag" type="button" class="table-page__icon-btn table-page__icon-btn--secondary"
          (click)="regresaProyectos()" aria-label="Regresar">
          <i class="material-icons">reply</i>
        </button>

        <button type="button" mat-raised-button class="btn table-page__primary-btn" (click)="altaModificarArea(null)">
          <i class="material-icons">add</i>
          <span>Alta de Área</span>
        </button>
      </div>
    </section>

    <!-- ==================== PESTAÑAS ==================== -->
    <nav class="areas-tabs">
      <button
        type="button"
        class="areas-tabs__t"
        [class.is-on]="pestana === 'areas'"
        (click)="pestana = 'areas'"
      >
        <i class="material-icons">list_alt</i>
        Áreas
      </button>
      <button
        type="button"
        class="areas-tabs__t"
        [class.is-on]="pestana === 'organigrama'"
        (click)="pestana = 'organigrama'"
      >
        <i class="material-icons">account_tree</i>
        Organigrama
      </button>
    </nav>

    <!-- El organigrama se monta hasta entrar: trae cuarenta y tantos
         nodos y todas las personas, y quien sólo viene a dar de alta
         un área no tiene por qué esperar eso. -->
    <app-organigrama *ngIf="pestana === 'organigrama'"></app-organigrama>

    <section class="table-page__card" *ngIf="pestana === 'areas'">
      <div class="table-page__table-wrap">
        <table class="table-page__table" *ngIf="listaAreas.length > 0; else areasEmptyState">
          <thead>
            <tr>
              <th>Área</th>
              <th>Estatus</th>
              <th>Tipo</th>
              <th>Área Default</th>
              <th class="table-page__actions-head">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of listaAreas">
              <td>
                <strong class="table-page__name">{{ row.area }}</strong>
              </td>
              <td>
                <span class="table-page__status-badge" [ngClass]="getStatusClass(row)">
                  {{ row.estatus }}
                </span>
              </td>
              <td>
                <span class="table-page__text">{{ getTypeLabel(row) }}</span>
              </td>
              <td>
                <div class="table-page__status-wrap">
                  <span class="table-page__subtext">Predeterminada</span>
                  <mat-slide-toggle [checked]="row.defaultService === 1 || row.defaultService === true"
                    (change)="onClicAcualizaStatus(row, $event)">
                  </mat-slide-toggle>
                </div>
              </td>
              <td class="table-page__actions">
                <button type="button" class="table-page__action-btn" (click)="altaModificarArea(row)">
                  <i class="material-icons">edit</i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <ng-template #areasEmptyState>
          <div class="table-page__empty" *ngIf="!loading; else areasLoadingState">
            <i class="material-icons">category</i>
            <strong>No se encontraron áreas</strong>
            <span>Registre una nueva área o ajuste la configuración para continuar.</span>
          </div>
        </ng-template>

        <ng-template #areasLoadingState>
          <div class="table-page__empty table-page__empty--loading">
            <i class="material-icons">hourglass_top</i>
            <strong>Cargando áreas...</strong>
          </div>
        </ng-template>
      </div>

      <div class="table-page__footer" *ngIf="showPagination">
        <div class="table-page__meta">
          <span>Mostrando {{ rangeEnd }} de {{ totalRegistros }} áreas</span>
          <span>Página {{ currentPage }} de {{ totalPages || 1 }}</span>

          <label class="table-page__page-size">
            <span>Ver:</span>
            <select [ngModel]="pageSize" (ngModelChange)="onPageSizeChange($event)">
              <option *ngFor="let option of pageSizeOptions" [ngValue]="option">{{ option }}</option>
            </select>
          </label>
        </div>

        <div class="table-page__pager" *ngIf="totalPages > 0">
          <button type="button" class="table-page__pager-link" (click)="firstPage()" [disabled]="currentPage === 1">
            Inicio
          </button>
          <button type="button" class="table-page__pager-link" (click)="previousPage()"
            [disabled]="currentPage === 1">
            Anterior
          </button>

          <ng-container *ngFor="let item of getPaginationItems()">
            <button *ngIf="isPageNumber(item); else areasPagerEllipsis" type="button" class="table-page__pager-page"
              [class.is-current]="item === currentPage" (click)="onPageChange(item)">
              {{ item }}
            </button>

            <ng-template #areasPagerEllipsis>
              <span class="table-page__pager-ellipsis">...</span>
            </ng-template>
          </ng-container>

          <button type="button" class="table-page__pager-link" (click)="nextPage()"
            [disabled]="currentPage === totalPages">
            Siguiente
          </button>
          <button type="button" class="table-page__pager-link" (click)="lastPage()"
            [disabled]="currentPage === totalPages">
            Último
          </button>
        </div>
      </div>
    </section>
  </div>
</div>
